// @ts-nocheck

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  logo: "",
  banner: "",
  tournamentData: null,
  organizerData: {},
  activeTab: "All",
  tournamentId: "",
  avlLocations: [],
  avlCategory: [],
  avlTournamentType: [],
  avlStatus: [],
  avlMatchType: [],
  location: [],
  category: [],
  tournamentType: [],
  matchType: [],
  status: [],
  specificTournamentData: {},
  allRounds: [],
};

export const tournamentSlice = createSlice({
  name: "tournaments",
  initialState: initialState,
  reducers: {
    setTournamentLogo: (state, action) => {
      console.log("ACTION PAYLOAD", action.payload);
      state.logo = action.payload;
    },
    setTournamentBanner: (state, action) => {
      state.banner = action.payload;
    },
    setTournamentData: (state, action) => {
      // console.log('TOurnamMent Data*******', state);
      state.tournamentData = action.payload;
    },
    setSpicificTournamentData: (state, action) => {
      state.specificTournamentData = action.payload;
    },
    setRemovePlayerMember: (state, action) => {
      state.specificTournamentData.teamMembers =
        state.specificTournamentData.teamMembers.filter(
          (item) => item._id !== action.payload
        );
    },
    pushPlayerToTournament: (state, action) => {
      let temp = [];
      if (!state?.specificTournamentData?.teamMembers) {
        return;
      }

      const index = state?.specificTournamentData?.teamMembers?.findIndex(
        (member) => member?.playerId?._id === action.payload[0]?.playerId?._id
      );

      if (index !== -1) {
        state.specificTournamentData.teamMembers[index] = action?.payload[0];
      } else {
        temp = [
          ...state?.specificTournamentData?.teamMembers,
          ...action?.payload,
        ];
        state.specificTournamentData.teamMembers = [...temp];
      }
    },
    pushTeamsToTournamnets: (state, action) => {
      let team = [];
      team = [...state.specificTournamentData.teams, ...action.payload];
      state.specificTournamentData.teams = [...team];
    },
    updateAuctionDetailsAfterEdit: (state, action) => {
      console.log("auction edit state updated");
      state.specificTournamentData.auctionDetails.pointsPerTeam =
        action.payload.pointsPerTeam;
      state.specificTournamentData.auctionDetails.minimumBid =
        action.payload.minimumBid;
      state.specificTournamentData.auctionDetails.bidRanges =
        action.payload.bidRanges;
    },
    updateAuctionDetailsAfterDeclare: (state, action) => {
      state.specificTournamentData.auctionDetails.isStarted =
        action.payload.isStarted;
      state.specificTournamentData.auctionDetails.isPaused =
        action.payload.isPaused;
      state.specificTournamentData.auctionDetails.isEnd = action.payload.isEnd;
    },
    pushTeamsToAuction: (state, action) => {
      console.log("bugFix pushTeamsToAuction payload", action.payload);
      state.specificTournamentData.auctionDetails.auctionTeams = [
        ...state.specificTournamentData.auctionDetails.auctionTeams,
        ...action.payload,
      ];
    },
    updateAuctionTeam: (state, action) => {
      const index =
        state.specificTournamentData.auctionDetails.auctionTeams.findIndex(
          (team) => team.teamId === action.payload.teamId
        );

      console.log(
        "auction data updateAuctionTeam found",
        state.specificTournamentData.auctionDetails.auctionTeams[index]
      );

      state.specificTournamentData.auctionDetails.auctionTeams[index] =
        action.payload;
    },
    setOrganizerData: (state, action) => {
      // console.log('TOurnamMent Data*******', state);
      state.organizerData = action.payload;
    },
    setTournamentId: (state, action) => {
      state.tournamentId = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    // expects a key values pair of data{name of state,value}
    setAvlData: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
    // expects a key values pair of data{name of state,value}
    setTournamentFilters: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
    resetTournamentFilters: (state, action) => {
      state.location = [];
      state.category = [];
      state.tournamentType = [];
      state.matchType = [];
      state.status = [];
    },
    pushFollower: (state, action) => {
      let specificId = state.specificTournamentData._id;
      let newData = state.tournamentData.map((item) => {
        if (item._id === specificId) {
          item.followers.push(action.payload);
          console.log(item, "following this");
        }
        return item;
      });

      state.tournamentData = newData;
    },
    removeFollower: (state, action) => {
      // 0(n^2)
      let specificId = state.specificTournamentData._id;
      let newData = state.tournamentData.map((item) => {
        // 0(n)
        if (item._id === specificId) {
          let newArr = item.followers.filter(
            //
            (item) => item._id !== action.payload._id
          );
          item.followers = newArr;
        }
        return item;
      });

      state.tournamentData = newData;
    },
    setGroups: (state, action) => {
      state.specificTournamentData.groups = [...action.payload];
    },
    setSaveRounds: (state, action) => {
      state.specificTournamentData.rounds = action.payload;
    },
    removeRound: (state, action) => {
      const index = state.specificTournamentData.rounds.findIndex(
        (id) => id === action.payload
      );
      if (index !== -1) {
        state.specificTournamentData.rounds.splice(index, 1);
      }
    },
    setAllRounds: (state, action) => {
      // console.log(action.payload, 'ALL ROUNDS');
      state.allRounds = action.payload;
    },
    addTeamToGroup: (state, action) => {
      console.log(action.payload, "ADD TEAM TO GROUP");
      const { number, teams } = action.payload;
      const index = state.specificTournamentData.groups.findIndex(
        (data) => data?.number === number
      );
      if (index !== -1) {
        state.specificTournamentData.groups[index] = action.payload;
      }
    },
    setSpecificTournamentEmty: (state, action) => {
      state.specificTournamentData = {};
    },
  },
});

export const {
  setTournamentLogo,
  setTournamentBanner,
  setTournamentData,
  setOrganizerData,
  setTournamentId,
  setActiveTab,
  setAvlData,
  setTournamentFilters,
  resetTournamentFilters,
  pushFollower,
  removeFollower,
  setSpicificTournamentData,
  pushPlayerToTournament,
  pushTeamsToTournamnets,
  setGroups,
  addTeamToGroup,
  setSaveRounds,
  setAllRounds,
  removeRound,
  setSpecificTournamentEmty,
  updateAuctionDetailsAfterEdit,
  pushTeamsToAuction,
  setRemovePlayerMember,
  updateAuctionDetailsAfterDeclare,
  updateAuctionTeam,
} = tournamentSlice.actions;
export default tournamentSlice.reducer;
